















import { Component, Prop, Vue } from 'vue-property-decorator'
import { IUser } from '@/store/modules/auth'
import { SUBSCRIPTION_TYPES, SUBSCRIPTION_PAYPAL_EXTRA_FEE, CURRENCIES, isProduction } from '@/constants'
import { formatCurrency } from '@/helpers/currency'

@Component({
  components: {
    HelpCircle: require('@/components/HelpCircle').default
  }
})
export default class PaypalCheckout extends Vue {
  loading: boolean = false

  @Prop()
  selectedPlan: SUBSCRIPTION_TYPES

  @Prop()
  currency: CURRENCIES

  get paypalExtraFee() {
    return formatCurrency(SUBSCRIPTION_PAYPAL_EXTRA_FEE[this.selectedPlan][this.currency], null, this.currency)
  }

  get user(): IUser {
    return this.$store.state.auth.user
  }

  get paypalUrl(): string {
    if (isProduction) return 'https://www.paypal.com/cgi-bin/webscr'
    else return 'https://www.sandbox.paypal.com/cgi-bin/webscr'
  }

  get paypalPlanId(): string | undefined {
    if (this.selectedPlan === SUBSCRIPTION_TYPES.Year) {
      if (this.currency === CURRENCIES.USD) return process.env.VUE_APP_PAYPAL_PLAN_YEARLY_USD
      if (this.currency === CURRENCIES.GBP) return process.env.VUE_APP_PAYPAL_PLAN_YEARLY_GBP
      if (this.currency === CURRENCIES.EUR) return process.env.VUE_APP_PAYPAL_PLAN_YEARLY_EUR
    } else if (this.selectedPlan === SUBSCRIPTION_TYPES.Month) {
      if (this.currency === CURRENCIES.USD) return process.env.VUE_APP_PAYPAL_PLAN_MONTHLY_USD
      if (this.currency === CURRENCIES.GBP) return process.env.VUE_APP_PAYPAL_PLAN_MONTHLY_GBP
      if (this.currency === CURRENCIES.EUR) return process.env.VUE_APP_PAYPAL_PLAN_MONTHLY_EUR
    } else throw new Error('unknown subscription plan: ' + this.selectedPlan + ' ' + this.currency)
  }
}
